import GeniePage from "../../../components/special/genie-page/GeniePage";
import GenieText from "../../../components/core/genie-text/GenieText";
import Box from "@mui/material/Box";
import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import GenieStickyHeader from "../../../components/core/genie-sticky-header/GenieStickyHeader";
import GenieEmpty from "../../../components/core/genie-empty/GenieEmpty";
import GenieTableLoad from "../../../components/core/genie-table-load/GenieTableLoad";
import { useParams } from "react-router-dom";
import useOrdersForCustomer from "../../../queries/routes/useOrdersForCustomer";
import { ArrowForward } from "@mui/icons-material";
import { formatCurrency } from "../../../utils/currency";
import { readableDateTime } from "../../../utils/date";
import ViewOrderDialog from "./ViewOrderDialog";

import { Nullable } from "../../../utils/Nullable";
import { Order } from "../../../types/api/Order";
import { theme } from "../../../components/special/genie-theme/genie-theme";

function AdminCustomerOrders() {
  const { org_id, customer_id } = useParams();
  const { data: orders, isLoading } = useOrdersForCustomer(
    org_id!,
    customer_id!
  );

  const [dialogOpen, setDialogOpen] = useState(false);
  const [trackingOrder, setTrackingOrder] = useState<Nullable<Order>>(null);

  function setClosed() {
    setDialogOpen(false);
  }

  return (
    <GeniePage noMargin>
      <GenieStickyHeader>
        <Stack flexDirection={"row"} width={"100%"} alignItems={"center"}>
          <GenieText
            fontSize={"medium"}
            fontWeight={"bold"}
            link={`/app/${org_id}/customers`}
          >
            Customers
          </GenieText>
          <ArrowForward sx={{ mx: 4 }} />
          <GenieText fontSize={"small"} fontWeight={"bold"}>
            {orders?.[0]?.organization?.name}
          </GenieText>
        </Stack>
      </GenieStickyHeader>
      <Box mt={4}>
        {isLoading && (
          <GenieTableLoad
            rowCount={10}
            columnCount={4}
            sx={{ minWidth: 650 }}
          />
        )}
        {!isLoading && orders?.length === 0 && (
          <GenieEmpty>You don't have any orders yet.</GenieEmpty>
        )}
      </Box>
      {!isLoading && orders && orders.length > 0 && (
        <TableContainer component={Box}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Order Date</TableCell>
                <TableCell align="left">Total Cost</TableCell>
                <TableCell align="right">Invoice</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orders.map((order) => (
                <TableRow key={order.id}>
                  <TableCell align="left">
                    {readableDateTime(order.completed_on)}
                  </TableCell>
                  <TableCell align="left">
                    {formatCurrency(order.cart.total_cents)}
                  </TableCell>
                  <TableCell align="right">
                    {order.invoice?.link ? (
                      <GenieText
                        blank={true}
                        fontSize={"tiny"}
                        link={order.invoice?.link || "#"}
                        uppercase
                      >
                        Payment Invoice
                      </GenieText>
                    ) : (
                      "N/A"
                    )}
                  </TableCell>
                  <TableCell align="right">
                    <GenieText
                      style={{
                        cursor: "pointer",
                        color: theme.palette.primary.main,
                      }}
                      underline={true}
                      fontSize={"tiny"}
                      onClick={() => {
                        setDialogOpen(true);
                        setTrackingOrder(order);
                      }}
                    >
                      View Order
                    </GenieText>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <ViewOrderDialog
        order={trackingOrder}
        open={dialogOpen}
        setClosed={setClosed}
      />
    </GeniePage>
  );
}

export default AdminCustomerOrders;
